const profile = {
  accountEmail: 'Account Email',
  accountEmailEn: '',
  noEmail: 'No Email Linked',
  membership: 'Membership',
  membershipEn: '',
  memberVip: 'VIP CLUB',
  memberRegular: 'MEMBER',
  memberBenefits: 'View Membership Benefits',
  memberBenefitsTitle: 'Available Benefits',
  memberBenefitsVipTitle: 'VIP Benefits',
  memberBenefitsRegularTip: 'Upgrade to VIP to unlock unlimited resume import.',
  benefitsShort: 'Perks',
  memberBenefitUnlimitedImport: 'Unlimited resume import',
  memberBenefitFilters:
    'Filters: activity, intent, age, function, location, China Exp.',
  memberBenefitCandidateManage: 'Candidate management & nationality tags',
  memberBenefitLanguageEdu: 'Language & education level',
  memberBenefitCompanyEmailName: 'Company, email, and name',
  memberBenefitJobHopping: 'Job-hopping frequency feature',
  vipShort: 'VIP',
  freePlan: 'Free',
  vipStatus: 'VIP Status',
  isVip: 'VIP Activated',
  planNames: {
    free: 'Free Plan',
    vip: 'Membership',
    trial: 'Trial Membership',
    basic: 'Basic Membership',
    professional: 'Professional Membership',
    professionalPro: 'Professional Pro Membership',
    team: 'Professional Pro Membership',
    enterpriseStandard: 'Enterprise Membership',
    enterpriseGrowth: 'Enterprise Membership',
    personal: 'Basic Membership',
    personalQuarterly: 'Basic Membership',
    pro: 'Pro Plan',
    business: 'Business Plan',
    enterprise: 'Enterprise Membership',
    subscription: 'Subscription Plan',
  },
  vipExpireAt: 'Membership Expires',
  vipExpireInDays: 'Expires in {days} days',
  currentMembership: 'Current entitlement',
  entitlementProviderLegacy: 'Legacy or granted membership',
  entitlementProviderWecom: 'WeCom',
  entitlementProviderWaffo: 'Waffo',
  entitlementProviderDesc: 'Entitlement source: {provider}.',
  membershipStatus: {
    active: 'Membership active',
    trialing: 'Trialing',
    canceling: 'Membership active',
    canceled: 'Membership ended',
    past_due: 'Membership issue',
    expired: 'Membership expired',
  },
  membershipActiveDesc: 'Membership benefits are currently available.',
  membershipActiveUntilDesc: 'Membership benefits are valid until {date}.',
  membershipPastDueDesc: 'Membership status needs attention. Please contact support.',
  membershipEndedDesc: 'Membership benefits have ended.',
  subscription: 'Auto-renewal subscription',
  subscriptionStatus: {
    active: 'Auto-renewal active',
    trialing: 'Trialing',
    canceling: 'Auto-renewal cancelled',
    canceled: 'Membership ended',
    past_due: 'Renewal failed',
    expired: 'Membership expired',
  },
  subscriptionTrialingDesc:
    'Trialing now. Payment will be charged automatically after the trial ends.',
  subscriptionActiveDesc: 'Subscription is active and will renew automatically.',
  subscriptionCancelingDesc:
    'Auto-renewal has been cancelled. Membership remains available until {date}.',
  subscriptionPastDueDesc: 'Renewal failed. Please update your payment method or subscribe again.',
  subscriptionEndedDesc: 'The current subscription has ended.',
  cancelAutoRenew: 'Cancel auto-renewal',
  cancelAutoRenewLoading: 'Cancelling...',
  cancelAutoRenewTitle: 'Cancel auto-renewal',
  cancelAutoRenewDesc:
    'After cancellation, your current membership remains active until {date}. You will not be charged again.',
  cancelAutoRenewConfirm: 'Confirm cancellation',
  cancelAutoRenewSuccess: 'Auto-renewal has been cancelled',
  cancelAutoRenewFailed: 'Failed to cancel auto-renewal. Please try again later.',
  notVip: 'VIP Not Activated',
  close: 'Close',
  contactSalesTitle: 'Contact Sales for VIP',
  contactSalesDesc:
    'Scan the QR code or use the lower-left corner of the page to get VIP privileges.',
  contactSalesAlt: 'Contact Sales',
  username: 'Username',
  fullName: 'Full Name',
  avatarUrl: 'Avatar URL',
  switchAvatar: 'Switch',
  avatarSourceProfile: 'Current avatar',
  avatarSourceOther: 'Other avatar',
  avatarSwitched: 'Avatar switched',
  usernamePlaceholder: 'Enter username',
  fullNamePlaceholder: 'Enter full name',
  avatarUrlPlaceholder: 'Enter avatar URL (https://...)',
  updateBasicInfo: 'Update Basic Info',
  updating: 'Updating...',
  updateSuccess: 'Updated successfully',
  updateFailed: 'Update failed',
  noChanges: 'No changes to update',
  invalidAvatarUrl: 'Invalid avatar URL format',
  guest: 'Guest',
  user: 'User',
  notLoggedIn: 'Not Logged In',
  unknownUser: 'Unknown User',
  socialConnections: 'Social Connections',
  socialConnectionsEn: 'Social Connections',
  link: 'Link',
  linked: 'Linked',
  unlink: 'Unlink',
  google: 'Google',
  feishu: 'Feishu',
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  linkSuccess: 'Linked successfully',
  unlinkSuccess: 'Unlinked successfully',
  linkFailed: 'Link failed',
  linkSessionInvalid:
    'The linking session validation failed. Please restart linking from your profile.',
  linkSessionExpired: 'The linking session has expired. Please start the linking flow again.',
  unlinkFailed: 'Unlink failed',
  unlinkConfirmTitle: 'Confirm unlink',
  unlinkConfirmMessage: 'Are you sure you want to unlink {provider}?',
  connectorIdMissing: 'Connector ID missing, please check configuration',
  notLinkedYet: 'This social account is not linked yet',
  verificationIdTitle: 'Security Verification',
  verificationMethodPrompt:
    'Choose a verification method for this sensitive action. Email code is recommended.',
  verifyByPassword: 'Verify by EasyHireAI password',
  verifyByEmail: 'Verify by email code',
  continueWithEmail: 'Continue with email code',
  passwordPrompt: 'Enter your current account password to continue.',
  passwordPlaceholder: 'Enter password',
  passwordRequired: 'Password is required',
  setPassword: 'Set password',
  passwordSetupHint:
    'This account has not set an EasyHireAI password yet. Linking will use email verification first.',
  passwordSetupGuidePrompt:
    'This account signs in with social login only and has not set an EasyHireAI password yet. Continue with email verification now, or set a password first for future password verification.',
  noEmailPasswordSetupPrompt:
    'No verified email is available for this account, and no EasyHireAI password has been set yet. Please set a password first and try again.',
  verificationCodeSent: 'Verification code sent to your account email',
  emailCodePrompt: 'Enter the 6-digit verification code sent to {email}.',
  emailCodePlaceholder: 'Enter verification code',
  emailCodeRequired: 'Verification code is required',
  noEmailForVerification: 'No linked email was found for verification',
}

export default profile
